import styled, { css } from "styled-components"

export const Container = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
  visibility: hidden;
  ${props =>
    props.active
      ? css`
          visibility: visible;
        `
      : ""}

  &:hover,
  &:focus {
    #rect {
      -webkit-transition: opacity 100ms ease-in;
      -o-transition: opacity 100ms ease-in;
      transition: opacity 100ms ease-in;
      opacity: 0.75;
    }
  }
`
